import { Box, Grid, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { Icon } from "../../../../../components/base";
import { getData } from "../../../../../services";
import { DOWNLOADED_EXCEL_FILE_TYPE } from "../../../../../constants";
import { ShaDowBox } from "../../../../../components/boxes";
import { NoDataCard } from "../../../../../components/parts";
import DocImg from "../../../../../assets/images/icons/doc.svg";

const useStyles = makeStyles(() => ({
  text: {
    color: COLORS.blue,
    cursor: "pointer",
  },
}));

const DOWNLOADED_FILE_NAME = "units_list.xlsx";

export const Documents = ({ doc, buildingId }) => {
  const classes = useStyles();
  const title = "Missing Connection Documents";
  const url = `/praas/v2/buildings/${buildingId}`;

  if (!doc) return <NoDataCard title={title} />;

  const downloadFile = () => {
    getData(
      `${url}/download-missing-docs/`,
      (data) => {
        const file = new Blob([data], { type: DOWNLOADED_EXCEL_FILE_TYPE });
        const element = document.createElement("a");
        element.href = URL.createObjectURL(file);
        element.download = DOWNLOADED_FILE_NAME;
        document.body.appendChild(element);
        element.click();
      },
      null,
      {
        responseType: "blob",
      }
    );
  };

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4" style={{ color: COLORS.red }}>
          {title}
        </Typography>
        <Box style={{ marginTop: 56 }}>
          <Grid container alignItems="center">
            <Grid item xs={1}>
              <Icon src={DocImg} />
            </Grid>
            <Grid item>
              <Typography className={classes.text} onClick={downloadFile}>
                {doc.file.split("/").pop()}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </ShaDowBox>
  );
};
